module.exports = __webpack_public_path__ + "img/veritas.ea65ce90.png";